import { createSlice } from "@reduxjs/toolkit";
import { LayoutDirection, LayoutPosition, LayoutTheme, LayoutWidth, SideBarTheme, SideBarType, TopBarTheme } from "../../constants/layout";

export type sideBarlayoutProps={
  layoutTheme: LayoutTheme,
  layoutDirection: LayoutDirection,
  layoutWidth: LayoutWidth,
  topBarTheme: TopBarTheme,
  sideBarTheme: SideBarTheme,
  sideBarType: SideBarType,
  layoutPosition: LayoutPosition,
  showSideBarUserInfo: boolean,
  isOpenRightSideBar: boolean,
}
export const sideBarlayoutSlice = createSlice({
  name: "sideBarlayout",
  initialState: {
    layoutTheme: LayoutTheme.THEME_LIGHT,
    layoutDirection: LayoutDirection.LEFT_TO_RIGHT,
    layoutWidth: LayoutWidth.LAYOUT_WIDTH_FLUID,
    topBarTheme: TopBarTheme.TOPBAR_LIGHT,
    sideBarTheme: SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT,
    sideBarType: SideBarType.LEFT_SIDEBAR_TYPE_DEFAULT,
    layoutPosition: LayoutPosition.POSITION_FIXED,
    showSideBarUserInfo: false,
    isOpenRightSideBar: false,
  },
  reducers: {
    changeSideBarType: (state, action) => {
      state.sideBarType = action.payload;
      return state;
    }, 
  },
});
export const { changeSideBarType } = sideBarlayoutSlice.actions;

export const sideBarlayoutSelector = (state:any) => state.sideBarlayout;

export const sideBarlayoutReducer = sideBarlayoutSlice.reducer;